import React from "react";
import { motion } from "framer-motion";
import { Leaf, Users, Clock, Award, Shield, Wrench } from "lucide-react";

const REASONS = [
  {
    Icon: Users,
    title: "Équipe qualifiée",
    desc: "Personnel formé, déclaré et supervisé par un chef de site dédié à votre établissement.",
  },
  {
    Icon: Leaf,
    title: "Produits éco-responsables",
    desc: "Gammes certifiées, respectueuses des surfaces et de l'environnement de travail.",
  },
  {
    Icon: Clock,
    title: "Réactivité 24/7",
    desc: "Intervention rapide en cas d'urgence, astreinte disponible pour sinistres et imprévus.",
  },
  {
    Icon: Award,
    title: "Qualité garantie",
    desc: "Contrôles visuels et cahier de liaison pour un suivi transparent et sans accroc.",
  },
  {
    Icon: Shield,
    title: "Entreprise assurée",
    desc: "Responsabilité civile professionnelle, conformité RGPD et confidentialité totale.",
  },
  {
    Icon: Wrench,
    title: "Matériel performant",
    desc: "Monobrosses, auto-laveuses, nettoyeurs haute pression et équipements professionnels.",
  },
];

const bgImage =
  "https://images.unsplash.com/photo-1771678039697-be711cc352e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHxjbGVhbiUyMG1vZGVybiUyMGludGVyaW9yJTIwc3BhY2V8ZW58MHx8fHwxNzc3OTkwNzM0fDA&ixlib=rb-4.1.0&q=85";

export default function WhyUs() {
  return (
    <section className="relative py-24 md:py-32 bg-[#0A1930] text-white overflow-hidden" data-testid="whyus-section">
      <div className="absolute inset-0 opacity-20">
        <img src={bgImage} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1930] via-[#0A1930]/95 to-[#0A1930]/70" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-6">
            <div className="text-xs uppercase tracking-[0.3em] text-[#2E9E6E] font-medium mb-4">
              — Pourquoi Néma Services
            </div>
            <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              Un partenaire de confiance, pas un simple prestataire.
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 flex items-end">
            <p className="text-slate-300 leading-relaxed">
              Nous croyons qu'un espace propre participe directement à la
              performance et à l'image de votre entreprise. C'est pourquoi
              chaque intervention est pensée comme un engagement durable.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10">
          {REASONS.map((r, i) => (
            <motion.div
              key={r.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="group bg-[#0A1930] p-8 md:p-10 hover:bg-[#0F2B5B] transition-colors"
              data-testid={`reason-${i}`}
            >
              <r.Icon className="w-8 h-8 text-[#2E9E6E] group-hover:scale-110 transition-transform" strokeWidth={1.5} />
              <h3 className="mt-6 font-display text-xl font-semibold text-white leading-tight">
                {r.title}
              </h3>
              <p className="mt-3 text-sm text-slate-300 leading-relaxed">
                {r.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
